import type { LinkProps } from "@/modules/routing/components/Link"
import type { FunctionComponent } from "react"

import { Link } from "@/modules/routing/components/Link"

export const ShallowLink: FunctionComponent<LinkProps> = ({ children, ...props }) => (
  <Link {...props} shallow>
    {children}
  </Link>
)
